import mProductTypes from './m-product-type.js';

class MCatalogFilter {
	constructor(/** @type {HTMLFormElement} */element) {
		this.element = element;
		/** @type {HTMLFormControlsCollection} */
		this.inputElements = [...element.elements].filter((formControlElement) => formControlElement.type === 'radio');
		this.productTypeElements = document.querySelectorAll('.m-product-type');
		this.buttonResetElement = element.querySelector('button[data-action="reset"]');

		const toggleInputElement = (/** @type {HTMLInputElement} */ inputElement) => {
			const labelElement = inputElement.closest('.a-button');
			labelElement.toggleAttribute('data-selected', inputElement.checked);
		};

		this.inputElements.forEach((/** @type {HTMLInputElement} */ inputElement) => {
			inputElement.addEventListener('click', () => {
				// toggle all input elements with same name
				// eslint-disable-next-line no-param-reassign
				inputElement.checked = inputElement.closest('.a-button')?.dataset?.selected !== '';
				this.inputElements.forEach((_inputElement) => {
					if (_inputElement.name === inputElement.name) {
						toggleInputElement(_inputElement);
					}
				});
				this.filter();
			});
		});

		this.buttonResetElement?.addEventListener('click', () => {
			this.inputElements.forEach((/** @type {HTMLInputElement} */ inputElement) => {
				// eslint-disable-next-line no-param-reassign
				inputElement.checked = false;
				toggleInputElement(inputElement);
			});
			this.filter();
		});

		this.updateInputElements();
		this.updateButtonReset();
	}

	get filterObject() {
		return Object.fromEntries((new FormData(this.element)).entries());
	}

	/**
	 * Disables inputElement, when a click of the inputElement would result in zero items.
	 */
	updateInputElements() {
		this.inputElements.forEach((inputElement) => {
			const { filterObject } = this;
			filterObject[inputElement.name] = inputElement.value;
			const filteredMCatalogProductTypes = mProductTypes
				.filter((mProductType) => mProductType.shouldShow(filterObject));
			inputElement.parentElement.setAttribute('aria-disabled', filteredMCatalogProductTypes.length === 0);
			inputElement.toggleAttribute('disabled', filteredMCatalogProductTypes.length === 0);
		});
	}

	updateButtonReset() {
		const hasCheckedInputElements = this.inputElements.filter((_) => _.checked).length > 0;
		this.buttonResetElement?.toggleAttribute('disabled', !hasCheckedInputElements);
	}

	filter() {
		mProductTypes.forEach((mProductType) => {
			if (mProductType.shouldShow(this.filterObject)) {
				mProductType.show();
			} else {
				mProductType.hide();
			}
		});
		this.updateInputElements();
		this.updateButtonReset();
	}
}

const element = document.querySelector('.m-filter-catalog');
if (element) {
	// eslint-disable-next-line no-new
	new MCatalogFilter(element);
}
